import { Body } from "./Body";
import { Data } from "./Data";
import { Footer } from "./Footer";
import { Head } from "./Head";
import { Header } from "./Header";
import { Layout } from "./Layout";
import { Row } from "./Row";

export const Table = { Body, Data, Footer, Head, Header, Layout, Row };
